package com.essntl.features.category.domain.model

data class DynamicField(
    val fieldName: String,
    val showOnItinerary: Boolean,
)
